<template>
  <div v-if="$parent.getDisplayView()">
    <div v-if="$parent.getDisplayView()" id="chart-criteria-results" class="shadow">
      <div class="ml-auto d-flex">
        <h4 class="card-title text-primary w-100">Chart Criteria Selections</h4>
      </div>
      <div class="row">
        <div class="col-lg-2 col-sm-6 pb-1">
          <div class="chart-criteria-label">Survey Name</div>
          <div>{{ surveyName }}</div>
        </div>
        <div class="col-lg-2 col-sm-6 pb-1" v-for="(result, idxCriteriaResultsList) in criteriaResultsList" v-bind:key="idxCriteriaResultsList">
          <div v-if="result.displayValue.length > 0 && 'Competitor' != result.name">
            <div class="chart-criteria-label">{{ result.name }}</div>
            <div>{{ result.displayValue }}</div>
          </div>
        </div>
      </div>
      <div v-for="(companyList, idxCriteriaResultsCompanyList) in criteriaResultsCompanyList" v-bind:key="idxCriteriaResultsCompanyList" class="row">
        <div v-if="companyList.list.length > 0 && companyList.label !== 'Client'" class="col-sm-12 chart-criteria-label">{{ companyList.label }}</div>
        <div v-if="companyList.list.length > 0 && companyList.label !== 'Client'" class="col-sm-12 chart-criteria-companies">
          <div class="chart-criteria-choice btn-secondary p-1 mr-1" v-for="(company, idxCompanyList) in companyList.list" v-bind:key="idxCompanyList">
            <span>{{ company.name }}</span
            ><span v-if="company.companyType === 'competitor' && company.numberOfResults >= 0" style="font-size: 10px"> (n={{ company.numberOfResults }}) </span>
            <div style="cursor: pointer" class="ml-2 close" aria-label="Close" @click="removeCompany(company, $event)">
              <span aria-hidden="true">×</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import ContentService from "../../services/content.service";

export default {
  name: "ChartCriteriaResults",
  data() {
    return {};
  },
  computed: {
    surveyName: function() {
      let returnName = this.$parent.survey.name;
      let resultClientList = this.criteriaResultsCompanyList.find(x => x.type === "client");
      if (typeof resultClientList !== "undefined") {
        if (resultClientList.list.length > 0) {
          returnName += " (n=" + resultClientList.list[0].numberOfResults + ")";
        }        
      }
      return returnName;
    }
  },
  props: {
    criteriaResultsCompanyList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    criteriaResultsList: {
      type: Array,
      default: function() {
        return [];
      }
    },
    isPredictiveAnalytics: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    removeCompany: function(competitor, event) {
      this.$parent.$refs.chartCriteria.$refs.chartCompany.removeCompany(competitor);
    }
  },
  mounted() {},
  created() {},
  watch: {}
};
</script>
